(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen-banners/assets/javascripts/banners.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen-banners/assets/javascripts/banners.js');

'use strict';

const _excluded = ["chances", "isSubscription", "endDate", "classNames", "isAndraChansenPeriodic"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const rowBanner = _ref => {
  let chances = _ref.chances,
    isSubscription = _ref.isSubscription,
    endDate = _ref.endDate,
    _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? [] : _ref$classNames,
    isAndraChansenPeriodic = _ref.isAndraChansenPeriodic,
    options = _objectWithoutProperties(_ref, _excluded);
  const banner = new svs.numbergames.andra_chansen_banners.AndraChansenRow(_objectSpread(_objectSpread({}, options), {}, {
    chances,
    isSubscription,
    endDate,
    classNames,
    isAndraChansenPeriodic
  }));
  return {
    render: () => {
      const el = document.createDocumentFragment();
      el.appendChild(banner.render());
      return el;
    },
    update: updatedOptions => {
      banner.update(updatedOptions);
    }
  };
};
const banners = {
  rowBanner
};
Object.assign(svs.numbergames.andra_chansen_banners, banners);

 })(window);